import { useAtom } from "jotai";

import { maxPercentSpendPerPrimaryBreakdownAtom } from "@features/mmm/budget-mix-provider";

export const useMaxPercentageSpendPerPrimaryBreakdown = () => {
  const [
    maxPercentageSpendPerPrimaryBreakdown,
    setMaxPercentageSpendPerPrimaryBreakdown,
  ] = useAtom(maxPercentSpendPerPrimaryBreakdownAtom);

  return [
    maxPercentageSpendPerPrimaryBreakdown,
    setMaxPercentageSpendPerPrimaryBreakdown,
  ] as const;
};
